import api from "../axiosIntercepture";

export const fetchCycleCount = async (page, pageSize) => {
    try {
        const response = await api.post(
            `/cycle-count/fetch-multi-dynamic`
        );
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
};



export const uploadCycleCount = async (file) => {
    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await api.post(
            "/upload/cycle-count",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
};





/* ================= FETCH REQUEST CYCLE COUNT ================= */
export const fetchRequestCycleCount = async (page = 0, pageSize = 10) => {
    try {
        const response = await api.post(
            "/cycle-count/fetch-request-cyclecount",
            {
                page,
                limit: pageSize
            }
        );

        // backend format: { data, totalCount, page, limit }
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch request cycle count";
    }
};

/* ================= CREATE REQUEST CYCLE COUNT ================= */
export const createRequestCycleCount = async (payload) => {
    try {
        const response = await api.post(
            "/cycle-count/create-cyclecount",
            payload,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;
    } catch (err) {
        throw err?.response?.data?.message || "Failed to create request";
    }
};



/* ================= VIEW CYCLE COUNT (BY ID) ================= */
export const fetchCycleCountViewById = async (cycleCountId) => {
    try {
        const response = await api.post(
            `/cycle-count/fetch-multi-dynamic?id=${cycleCountId}`,
            {}
        );

        // backend: response.data.data.data = [ { CycleCountHeader, CycleCountDetail } ]
        return response.data?.data?.data?.[0] || null;

    } catch (err) {
        throw err?.response?.data?.message || "Failed to fetch cycle count view data";
    }
};